import {
  CHEGG,
  CITATION_MACHINE,
  EASYBIB,
  CITE_THIS_FOR_ME,
  BIBME,
  CW,
  CM,
  EB,
  CTFM,
  BM,
} from '@chegg-wt/core/constants/site'
import { Site, SiteInitial } from '@chegg-wt/core/types/site'
import { BUSINESS_UNIT } from '../constants'

type GetUpdatedViewParams = {
  site: Site
  page: string
}

type ViewExperienceMap = Partial<Record<Site, SiteInitial>>

const viewExperienceMap: ViewExperienceMap = {
  [CHEGG]: CW,
  [EASYBIB]: EB,
  [CITATION_MACHINE]: CM,
  [CITE_THIS_FOR_ME]: CTFM,
  [BIBME]: BM,
}

export function getUpdatedView({ site, page }: GetUpdatedViewParams) {
  const property = site === CHEGG ? CHEGG : BUSINESS_UNIT
  return {
    property,
    experience: viewExperienceMap[site],
    view_name: page || '',
  }
}
